export default "__VITE_ASSET__BU9zbR1i__"